import React, { useMemo, useState, useEffect } from 'react';
import ModalBase from './ModalBase';


const imageLinks = [
  '1HWJ6EEN4P9Zae2XZCOXPg8k4QuwWhBiM',
  "1Zpjc8R--iZqnnfJgWUGdxtHj9LtpfvP5",
  '1e9Ef-gMxPWHQvVybZGCM3LYFdtZIOia4',
  '1RsFA_xdAA24E_8j3nvGyi3858gnagsQO',
  '11iQOzL1bAJaqVkD16nKpG2LBzEH_Dwox',
  '1ccAroklnqkYxgam7cNwsVmqiXWuUA9Ic',
  '1_5tcysrOoKXGa_0ENnNwAy0e3GdwQuLl',
  '1nvSBFLu7VgXmtP-VMR3k7RKwsZf1jJgn',
  '1fD3iTqbP5Qx-2L1AlDILaLxPZXDTk9kS',
  '1Fno2VMhTPYhpZHoGFxSN6Q1pLo_ZnzZP',
  '1Oo5H13dQ2g9jp5zRh7vAn9aCGyko64Sw',
  '12l_bmZy4YL9EBQ0pBu5FjBG5Nq5vLGyR',
  '1xV18zxvwbGBuT9vdxcRhxuSDOCutqjHd',
  '13YS6_nxTt4BzdO2fRZqr2nC4qCYhQ7yp',
  '1Ezkp389D_3mXzpSIkX6Pxvn41CWlXCCo',
  '16uv-avH6GNUOTKkUzx2wSnwua6ZAQSIE',
  '1Lepj_kLE2j4IYXe1WdWDDJn8bnbnIf0a',
  '1eWhj-zQHfzf9qDuACNEpUGdA9qghKSpc',
  '1waio0AJTDfi47fteOvQYR2kXGGcBV_d4',
  '1BBnptHtAbbS0hQ-21wgP0teKUg_HeFkX',
  '1HDB7ktcEryYBgITTFagzebnADQYjIx5C',
  '1EnXMk4GSbRRBx-k1Tu_IBdprRMUSVgWH',
  '1Dk_RVS1V-gRvSXaez_AUn7XfASMNtuCQ',
  '1hOfcm9jLhjTCxnkY-G_4fg8J3CphPvUt',
  '1cFfCEMVEjs45GzMes2aOixFEZzsBedi0',
  '1kc01xFRw8cgxetuqND2Z9Izk4Px2lLto',
  '1rOlBwfxxLG0u7ut2KdUG-xHbbmel9MI-',
  '1Qjys9qoRB6C6-RZ2q0ToVuyhRp-LOnqn',
  '1jjInhR7BkMEgRqXbIQgDme7G0bc6CC0d',
  '1knkx7vCQiW6uu8x9UwIWd1vh3SVUo8SS',
  '1_bBNxAscbc0a0gRb3K-u5HnZTkh2B5Xr',
  '1WTcSq2aWVff9QUn28UCxb-6va0gvPMRr',
  '1hVq6Va4e31rq5vakfdOBLgNVjmUYTu3f',
  '1HAe0Z7vktjIn37cYlHFYVaOmZ0pdUMHM',
  '1Gw20ffbP0fBM64duKrQ6k7cb624eegCz',
  '1y5FS4OIS3GfFjcL5enTRf2qoYksK73h1',
  '1gzIO5L2njgjmNKVWaATNa2ms_f6j6gbJ',
  '1WEDZCr_TvGgNNxnxit4DGYk5H340xL1I',
  '1zP1u1fWENpJ9MUKEXcbe3yr1R1jgtNj3',
  '11kFWijOznUe1dstFVVo9JHwU0GfeFIwF',
  '1em9bDDYgJRYZT3m5rs_EzOK52Ndt24ZA',
  '1hJk0MboOTxgYsRPsHeVUuZC_Kp5u0V_B',
  '1jeubPiEOij9qSflFGyz6JZ01ugyCjkRb',
  '1hnIOEEekIwfNAyJ2Htf8iA1jPMBrHLsx',
  '1bkUXQlUxL3ubRfbadhe-QEv49VQNWQGD',
  '1GVRtoUp8gIZ9d3nsLGYVfFvEa6Sygju3',
  '1TATdNqpZx2ybfDLxAMDVd4gW-DrlFQBa',
  '1G7BEScSE0Zi0N_cRz6ZXzNaCHoy0XEhA',
  '1GHkauIlY7Of7jV_SjSrteJU_kwUSDxgx',
  '1CiB7Apvbwrari7PqqEzSgi0GGYFy-Od9',
  '1fDXUHFSpvrw_aVfeupKy7elaAm8cmZ3r',
  '1q5VB9DvcOrbR70q8WHXtQBbSeP0y4gQi',
  '1dPltWrIn8QmanL4GiFnRk_LP2ZtvQTYD',
  '1dX62PE3Q_q04mJyomY3uqGnNrebJsYLV',
  '1YNk46O_l9mY1kuO6Mehp0Y5EWW07z4bw',
  '1HL7Y6I3gP8ThARMBf1ArRv-CwchpHzgi',
  '1uXY1Hr2lcz3d_V5AE7MJ62miiDuyzbfj',
  '1Bsnf3j363lxdKMlDUNX8N7jvRV1GWe_l',
  '1qxjrlMR6AhfvTsCVf411n6wRJRo1VNRX',
  '1m-55DBfN4The_j8giTGuGF89YbuwtnBO',
  '1BG803iUwaxl-WeRIa6ql_x_j552ggJJt',
  '1q4STWf1ziGHnsyNtfpWpI4CkGK-Nps24',
  '1DogolbJXF4Eo4UdQlckhjJ7v1PuAQ9ES',
  '1x2QQzb1f0b0J-NvfVK9SCGuo1VMYSESO',
  '1mVQLDF_XzUPV738Z0h14LXT4Rx7X4Vl2',
  '1WRR1f2RCA2EKpzbq27DQd2XPIOBhq41b',
  '1O7oKCQunyO8dfOfLyP4l34kOAq_GvTA7',
  '1-Dpth5eWTBIrgjOoMBtsgfaAiYXcGr6F',
  '1p6pcpDPAfPu0ylCAykUPOG3FSeDLPk6E',
  '1miCCKg7JqoH8F_KUXAAaWOMaORlxoHTR',
  '1FgmshsAESsXjsnfTRQtLMmvMItfkmdy-',
  '1vLg0V2VoYVhl4mHyPaQ4i8PlZGYBzoNf',
  '1NPN-mXwDq5ryCX6chcWGBV4vprAobE6j',
  '1ZrKpKNmRI5v4o6mLB7AZxf1yXf3VLeyt',
  '18b0LtqwKwMCprxUfun7Ah9Ru5u0AyVhd',
  '1bVANCfXQjV-ZIxAv1zQsKq6Bw0DVt72Y',
  '1SJ1iwjXNSVrAKyiupKY1Vv8OElwaBZSQ',
  '1UeaWeL9054gS1N3QiKxBe964Aso17IoK',
  '1swCLhULZaInHFafk2-4_u_5sGSQhO_ss',
  '11HWqlnYyprZb9hI3ElTaOl4im1kY-s6p',
  '1EZrv5VPF9fnODEUwjBPDX4Uk8Rchi9yG',
  '1DleQODTP8uZosi4rV7Q18Z5sV-sqX2w4',
  '1ALe8uz4FSXOy5qq3t08RT_-UjpFms8tI',
  '1d8_5RuA6n6xd8eNUU-r_fus6aU859fEQ',
  '1WRMKKakuOABvo0YbuIZeKWo1N67xZyhT',
  '10QcduismXQMCYaMLpZ9ZMGnbVCdtHW_8',
  '1LR9wekkZXxyq9HLtLBJj6E1iDja0cwGa',

];
const merchLinks = [
  'https://magnesio1864.net/MODELOFLASKING.jpg',
  'https://magnesio1864.net/MODELOMAGNESIO.jpg',
  'https://magnesio1864.net/Dekgrafis.jpg',
]
// Función para mezclar el array de imágenes
const shuffleArray = (array) => {
  const shuffled = array.slice();
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
const useResponsiveImageClasses = (shuffledImages) => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const imageSpanClasses = useMemo(() => {
    if (!isLargeScreen) return shuffledImages.map(() => '');
    return shuffledImages.map(() => (Math.random() > 0.98 ? 'row-span-2 col-span-2' : ''));
  }, [shuffledImages, isLargeScreen]);

  return imageSpanClasses;
};

const Galeria = ({ isOpen, onClose, merch, title }) => {
  // Mezclamos las imágenes y generamos el spanClass una sola vez por renderizado del componente
  const shuffledImages = useMemo(() => shuffleArray( merch ? merchLinks : imageLinks), []);

  // Generamos aleatoriamente el spanClass solo una vez por imagen
  const imageSpanClasses = useResponsiveImageClasses(shuffledImages);

 // Función para generar el link de WhatsApp con la imagen y el modelo
 const generateWhatsAppLink = (imageSrc, model) => {
  // URL base de WhatsApp
  const whatsappBaseUrl = 'https://api.whatsapp.com/send?phone=+541163065100&text=';
  // URL de la imagen de Google Drive (modificada para acceso directo)
  const imageUrl = imageSrc;
  // Mensaje que se va a enviar por WhatsApp
  const message = `¡Hola Magnesio! Estoy interesado en este producto. Modelo: ${imageUrl}`;
  const encodedMessage = encodeURIComponent(message);
  return `${whatsappBaseUrl}${encodedMessage}`;
};
  return (
    <ModalBase isOpen={isOpen} onClose={onClose} className={'bg-black text-white'} title={title}>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 grid-auto-rows-fr">
        {shuffledImages.map((src, index) => {
          const spanClass = imageSpanClasses[index]; // Asignamos el spanClass memorized
          const model = `Modelo ${index + 1}`; // Aquí defines el modelo de cada producto, puedes adaptarlo
          const whatsappLink = merch ? generateWhatsAppLink(src, model) : null;
          return (
        <div key={index} className={`${merch ? '' : spanClass} mt-6 group relative overflow-hidden rounded-lg shadow-lg`}>
          <img
            src={merch ? `${merchLinks[index]}` : `https://lh3.googleusercontent.com/d/${src}=s1024?authuser=0`}
            alt={`Imagen ${index + 1}`}
            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300 ease-in-out"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out flex items-center justify-center">
                {merch && (
                  <a
                  href={'https://api.whatsapp.com/send?phone=+541163065100&text=' + encodeURIComponent('¡Hola Magnesio! Estoy interesado en este producto. Modelo: ') + merchLinks[index]} // Enlace de WhatsApp con imagen
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 text-white px-4 py-2 rounded-md text-lg font-semibold hover:bg-green-600 transition-colors duration-300"
                >
                    Comprar
                  </a>
                )}
              </div>
        </div>
        )}
      )}
      </div>
    </ModalBase>
  );
};

export default Galeria;
